import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { IdleService } from '../service/idle.service';

export interface DeactivationGuarded
{
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateGuard 
{
    constructor(private idleService: IdleService) { }

    public canDeactivate(component: DeactivationGuarded): Observable<boolean> | Promise<boolean> | boolean
    {
        // If idle timed out and currently in edit mode, we automatically exit and discard any pending changes.
        if (this.idleService.timedOut)
        {
            return true;
        }
        else
        {
            return component.canDeactivate ? component.canDeactivate() : true;
        }
    }
}
